// font file
import { NextFontWithVariable } from 'next/dist/compiled/@next/font';
import localFont from 'next/font/local';
import {
  Noto_Serif,
  Libre_Bodoni,
  Arima,
  Noto_Sans,
  Playfair_Display,
} from 'next/font/google';

const notosans = Noto_Sans({
  preload: true,
  subsets: ['latin'],
  weight: ['300', '400', '500', '600', '700', '900'],
  style: ['normal'],
  display: 'swap',
  variable: '--font-notosans',
});

const notoserif = Noto_Serif({
  preload: true,
  subsets: ['latin'],
  weight: ['400', '500', '600', '700'],

  style: ['normal'],
  display: 'swap',
  variable: '--font-notoserif',
});

const playfair = Playfair_Display({
  preload: true,
  subsets: ['latin'],
  weight: ['400', '500', '600', '700', '800'],
  style: ['normal'],
  display: 'swap',
  variable: '--font-playfair',
});

// @ts-ignore
// const sf = localFont({
//   preload: true,
//   src: [
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/sf/sf-pro-display-light.woff2',
//       weight: '300',
//       style: 'normal',
//     },
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/sf/sf-pro-display-medium.woff2',
//       weight: '500',
//       style: 'normal',
//     },
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/sf/sf-pro-display-bold.woff2',
//       weight: '700',
//       style: 'normal',
//     },
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/sf/sf-pro-display-heavy.woff2',
//       weight: '800',
//       style: 'normal',
//     },
//   ],
//   display: 'swap',
//   variable: '--font-sf',
// });

const libre = Libre_Bodoni({
  preload: false,
  subsets: ['latin'],
  weight: ['700'],
  style: ['italic', 'normal'],
  display: 'swap',
  variable: '--font-libre',
});
// @ts-ignore
// const trt = localFont({
//   preload: false,
//   src: [
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/trt/TRT-Light.woff2',
//       weight: '300',
//       style: 'normal',
//     },
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/trt/TRT-Regular.woff2',
//       weight: '400',
//       style: 'normal',
//     },
//     {
//       path: 'https://cdn.jsdelivr.net/npm/payload-richtext-tiptap/dist/src/fonts/fonts/trt/TRT-Medium.woff2',
//       weight: '500',
//       style: 'normal',
//     },
//   ],
//   display: 'swap',
//   variable: '--font-trt',
// });

const arima = Arima({
  preload: false,
  subsets: ['latin'],
  display: 'swap',
  variable: '--font-arima',
  weight: ['500', '600', '700'],
});

const fonts = [
  // sf,
  notoserif,
  notosans,
  playfair,
  arima,
  // trt,
  libre,
] as NextFontWithVariable[];

export default fonts;
